import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { push } from "react-router-redux";
import { clearUser, getUser } from "utils/auth";
//antd
import { Layout, Menu, Icon, Row, Col } from "antd";

export class Dashboard extends Component {
  state = {
    collapsed: false
  };

  _handleClick = path => {
    const { redirect, match} = this.props;
    if (path === "/") {
      clearUser();
    }
    if (path === match.path) {
      window.location.reload();
    }

    return redirect(path);
  };

  onCollapse = collapsed => {
    this.setState({ collapsed });
  };

  _logout = async () => {
    const { redirect } = this.props;
    await clearUser();
    redirect("/");
  };

  render() {
    const { Content, Header, Sider } = Layout;
    const { path } = this.props.match;
    return (
      <Layout style={{ backgroundColor: "#FFF", minHeight: "100vh" }}>
        <Header
          style={{
            color: "#FFF",
            backgroundColor: "#2255ca",
            padding: "0 20px",
            justifyContent: "space-between"
          }}
        >
          <div className="navbar">
            <Row type="flex" align="middle">
              <Col span={12}>
                <Row type="flex" justify="start" align="middle">
                  <Col>
                    <img
                      alt="logo"
                      height="41"
                      width="145"
                      src="https://s3.amazonaws.com/wesolv-assets/WeSolvLogos/Logo_White.png"
                    />
                  </Col>
                  <Col style={{ fontSize: "28px", marginLeft: "15px" }}>
                    ADMIN
                  </Col>
                </Row>
              </Col>
              <Col span={12}>
                <Row type="flex" justify="end" align="middle">
                  <Col>{getUser().email}</Col>
                  <Col>
                    <a
                      onClick={() => this._logout()}
                      role="button"
                      style={{ color: "#FFFFFF", marginLeft: "15px" }}
                    >
                      LOGOUT
                    </a>
                  </Col>
                </Row>
              </Col>
            </Row>
          </div>
        </Header>
        <Layout style={{ background: "#fff", minHeight: "100%" }}>
          <Sider
            collapsible
            collapsed={this.state.collapsed}
            onCollapse={this.onCollapse}
            style={{
              backgroundColor: "#ffffff",
              borderRight: "1px solid #4a4a4a",
              minHeight: "100%"
            }}
          >
            <Menu
              theme="light"
              mode="inline"
              onClick={e => this._handleClick(e.key)}
              style={{ backgroundColor: "#ffffff" }}
              defaultSelectedKeys={[path]}
              height="100%"
            >
              <Menu.Item
                key="/companies"
                style={{ backgroundColor: "#FFF", color: "#4a4a4a" }}
              >
                <Icon type="team" />
                <span>COMPANIES</span>
              </Menu.Item>
              <Menu.Item
                key="/challenges"
                style={{ backgroundColor: "#FFF", color: "#4a4a4a" }}
              >
                <Icon type="layout" />
                <span>CHALLENGES</span>
              </Menu.Item>
              <Menu.Item
                key="/students"
                style={{ backgroundColor: "#FFF", color: "#4a4a4a" }}
              >
                <Icon type="user" />
                <span>WESOLVERS</span>
              </Menu.Item>
            </Menu>
          </Sider>
          <Layout style={{ background: "#fff", minHeight: "100%" }}>
            <Content style={{ background: "#fff", minHeight: "100%" }}>
              <div style={{ background: "#fff", minHeight: "100%" }}>
                <div>{this.props.children}</div>
              </div>
            </Content>
          </Layout>
        </Layout>
      </Layout>
    );
  }
}

export default connect(
  null,
  dispatch => ({
    redirect: bindActionCreators(push, dispatch)
  })
)(Dashboard);



// WEBPACK FOOTER //
// ./src/components/dashboard/index.js